import { render, staticRenderFns } from "./custom-select.vue?vue&type=template&id=0440d056"
import script from "./custom-select.vue?vue&type=script&lang=js"
export * from "./custom-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports